var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AbsBox',{staticClass:"d-flex rounded hovervis",staticStyle:{"cursor":"pointer"},style:(("background:" + _vm.color)),on:{"click":function($event){return _vm.$emit('click', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }